import React, { useState } from "react";
import styles from "./AnimalTable.module.css";

interface ProductData {
  key: number;
  region: string;
  counts: Record<string, number>;
}

const regions = [
  "Чуйская",
  "Ошская",
  "Нарынская",
  "Баткенская",
  "Таласская",
  "Иссык-Кульская",
  "Джалал-Абадская",
] as const;

const product = ["Молоко", "Шерсть", "Яйца", "Мясо"] as const;

const dataSource: ProductData[] = [
  {
    key: 0,
    region: "Чуйская",
    counts: {
        Молоко: 406417,
        Шерсть: 1049,
        Яйца: 355766,
        Мясо: 78142,
    },
  },
  {
    key: 1,
    region: "Баткенская",
    counts: {
        Молоко: 58823,
        Шерсть: 124,
        Яйца: 10768,
        Мясо: 22238,
    },
  },
  {
    key: 2,
    region: "Ошская",
    counts: {
        Молоко: 234977,
        Шерсть: 419,
        Яйца: 45247,
        Мясо: 42292,
    },
  },
  {
    key: 3,
    region: "Таласская",
    counts: {
        Молоко: 60928,
        Шерсть: 738,
        Яйца: 14146,
        Мясо: 18107,
    },
  },
  {
    key: 4,
    region: "Нарынская",
    counts: {
        Молоко: 107012,
        Шерсть: 1541,
        Яйца: 3634,
        Мясо: 34799,
    },
  },
  {
    key: 5,
    region: "Ыссык-Кульская",
    counts: {
        Молоко: 184492,
        Шерсть: 1745,
        Яйца: 23274,
        Мясо: 44368,
    },
  },
  {
    key: 6,
    region: "Джалал-Абадская",
    counts: {
        Молоко: 107012,
        Шерсть: 37,
        Яйца: 47790,
        Мясо: 49689,
    },
    
  },

];

export const ProductTable: React.FC = () => {
  const [selectedProduct, setSelectedProduct] = useState<typeof product[number]>(
    product[0]
  );

  const handleProductChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setSelectedProduct(event.target.value as typeof product[number]);
  };

  return (
    <div className={styles.container}>
      <div className={styles.container_inner}>
      <h2>Реализация по областям (Тонн)</h2>
      <select
        value={selectedProduct}
        onChange={handleProductChange}
        className={styles.select}
      >
        {product.map((product) => (
          <option key={product} value={product}>
            {product}
          </option>
        ))}
      </select>

      <ul className={styles.table}>
        <li className={styles.header}>
          <span className={styles.cell}>Область</span>
          <span className={styles.cell}>{selectedProduct}</span>
        </li>
        {dataSource.map((item) => (
          <li key={item.key} className={styles.row}>
            <span className={styles.cell}>{item.region}</span>
            <span className={styles.cell}>{item.counts[selectedProduct]}</span>
          </li>
        ))}
      </ul>
      </div>
    </div>
  );
};


